import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { LoggedInUserService } from '@vectronic/shared/data-access/logged-in-user';
import { CardComponent } from '@vectronic/ui';

@Component({
  selector: 'my-vectronic-profile-page',
  imports: [CardComponent, MatFormField, ReactiveFormsModule, MatLabel, MatInput],
  template: `<div class="wrapper">
    <vectronic-card title="Your Profile">
      <ng-container body>
        <div class="card-body">
          <form [formGroup]="profileForm">
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput placeholder="mail@example.com" formControlName="email" />
            </mat-form-field>
          </form>
        </div>
      </ng-container>
    </vectronic-card>
  </div>`,
  styles: `
    .wrapper {
      padding-top: 2rem;
      display: flex;
      justify-content: center;
    }

    vectronic-card {
      width: 80%;
      max-width: 1000px;
    }

    @media (max-width: 767px) {
      vectronic-card {
        width: 100%;
      }
    }

    .card-body {
      padding: 2rem;
    }

    mat-form-field {
      width: 100%;
    }
  `,
})
export class ProfilePageComponent {
  private fb = inject(FormBuilder);
  private loggedInUserService = inject(LoggedInUserService);

  profileForm: FormGroup = this.fb.group({
    email: { value: this.loggedInUserService.username(), disabled: true },
  });
}
